export default {
  title: {
    en: 'Choose the size of your gift',
  },
}
